if (!customElements.get('launch-product-finder')) {
  customElements.define(
    'launch-product-finder',
    class LaunchProductFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-lpf-track]');
        this.tabs = Array.from(this.querySelectorAll('[data-lpf-tab]'));
        this.prev = this.querySelector('[data-lpf-prev]');
        this.next = this.querySelector('[data-lpf-next]');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
        });

        this.prev?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.scroll(-1);
        });

        this.next?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.scroll(1);
        });

        this.track?.addEventListener(
          'scroll',
          () => this.requestArrowUpdate(),
          { passive: true }
        );

        window.addEventListener('resize', () => this.requestArrowUpdate());

        requestAnimationFrame(() => this.updateArrowState());
      }

      getVisibleCards() {
        return Array.from(
          this.querySelectorAll('[data-lpf-card]:not(.is-hidden)')
        );
      }

      activateTab(button) {
        const key = button.dataset.lpfTab;

        this.tabs.forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.querySelectorAll('[data-lpf-card]').forEach((card) => {
          const enabled =
            String(card.dataset.tabEnabled || '').trim() === 'true';

          card.classList.toggle(
            'is-hidden',
            !enabled || card.dataset.tab !== key
          );
        });

        if (this.track) {
          this.track.scrollTo({ left: 0, behavior: 'auto' });
        }

        requestAnimationFrame(() => this.updateArrowState());
      }

      scroll(direction) {
        if (!this.track) return;

        const cards = this.getVisibleCards();
        if (!cards.length) return;

        const gap = parseFloat(getComputedStyle(this.track).gap || '0');
        const step = cards[0].getBoundingClientRect().width + gap;

        if (!step) return;

        const currentIndex = Math.round(this.track.scrollLeft / step);
        const targetIndex = Math.max(
          0,
          Math.min(cards.length - 1, currentIndex + direction)
        );

        this.track.scrollTo({
          left: targetIndex * step,
          behavior: 'smooth'
        });
      }

      requestArrowUpdate() {
        if (this._arrowFrame) return;

        this._arrowFrame = requestAnimationFrame(() => {
          this._arrowFrame = null;
          this.updateArrowState();
        });
      }

      updateArrowState() {
        if (!this.track) return;

        const maxScroll = Math.max(
          0,
          this.track.scrollWidth - this.track.clientWidth
        );
        const tolerance = 3;

        if (this.prev) {
          this.prev.disabled = this.track.scrollLeft <= tolerance;
        }

        if (this.next) {
          this.next.disabled =
            this.track.scrollLeft >= maxScroll - tolerance || maxScroll <= tolerance;
        }
      }
    }
  );
}
